"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reject;
var _filter = _interopRequireDefault(require("./filter.js"));
var _negate = _interopRequireDefault(require("./negate.js"));
var _cb = _interopRequireDefault(require("./_cb.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Return all the elements for which a truth test fails.
function reject(obj, predicate, context) {
  return (0, _filter.default)(obj, (0, _negate.default)((0, _cb.default)(predicate)), context);
}